<script setup>
import { ref, computed } from "vue";
import SectionContainer from "./SectionContainer.vue";
import { ModuleManager } from "@module-system";

const props = defineProps({
  rtcId: {
    type: String,
    required: false,
  },
  sectionType: {
    type: String,
    required: true,
  },
  direction: {
    type: String,
    default: "auto",
  },
  size: {
    type: Number,
    default: 100,
  },
  manuelOpen: {
    type: Boolean,
    default: false,
  },
  closeDisabled: {
    type: Boolean,
    default: false,
  },
});
var directionProp = ref(props.direction);

var modules = ModuleManager.getViewModules(props.sectionType, props.rtcId);

let direction = "";
if (directionProp.value == "auto") {
  var checkName = props.sectionType.toLowerCase();
  direction = checkName.includes("top") ? "top" : direction;
  direction = checkName.includes("bottom") ? "bottom" : direction;
  direction = checkName.includes("left") ? "left" : direction;
  direction = checkName.includes("right") ? "right" : direction;
} else {
  direction = directionProp.value;
}

const emit = defineEmits(["set-panel-state"]);

let panelActive = ref(false);

const chevron = computed(() => {
  switch (direction) {
    case "top":
      // up or down
      return panelActive.value
        ? "mdi-chevron-up-circle"
        : "mdi-chevron-down-circle";
    case "bottom":
      return panelActive.value
        ? "mdi-chevron-down-circle "
        : "mdi-chevron-up-circle";
    case "left":
      return panelActive.value
        ? "mdi-chevron-left-circle"
        : "mdi-chevron-right";
    case "right":
      return panelActive.value
        ? "mdi-chevron-right-circle"
        : "mdi-chevron-left-circle";
    default:
      return panelActive.value
        ? "mdi-chevron-up-circle"
        : "mdi-chevron-down-circle";
  }
});

const customPanelSize = ref(null);

const calcPanelSize = computed(() => {
  if (customPanelSize.value) return customPanelSize.value;

  if (modules.value.length == 0) return 0;

  return props.size;
});

const containerCss = computed(() => {
  return `min-height: 0px; flex-basis:${
    panelActive.value ? calcPanelSize.value : 0
  }px`;
});

const setPanelState = (enabled) => {
  panelActive.value = enabled;
  emit("set-panel-state", enabled, props.sectionType);
};
const setPanelSize = (size) => {
  console.log(`panel ${props.sectionType} size set to ${size}`);
  customPanelSize.value = size;
};

const buttonShow = computed(() => {
  if (modules.value.length == 0) return false;

  if (panelActive.value) {
    return !props.closeDisabled;
  }

  return props.manuelOpen;
});

const windowSize = ref({
  width: window.innerWidth,
  height: window.innerHeight,
});

window.addEventListener("resize", () => {
  windowSize.value = {
    width: window.innerWidth,
    height: window.innerHeight,
  };
});

const isSmallScreen = computed(() => {
  if (!panelActive.value) return false;
  return windowSize.value.width < 768;
});
</script>

<template>
  <div class="flex-animate position-relative" :style="containerCss">
    <button
      @click="setPanelState(!panelActive)"
      v-if="buttonShow"
      :class="
        'section-close-button ' +
        direction +
        ' ' +
        (isSmallScreen ? 'is-mobile' : '')
      "
    >
      <v-icon :icon="chevron" aria-hidden="true" />
    </button>

    <SectionContainer
      v-show="panelActive"
      :rtc-id="props.rtcId"
      :section-type="props.sectionType"
      :show-back-button="isSmallScreen"
      @set-panel-state="setPanelState"
      @set-panel-size="setPanelSize"
    ></SectionContainer>
  </div>
</template>

<style>
.flex-animate {
  transition: flex 0.5s;
  min-width: 0;
}

.section-close-button {
  position: absolute;
  width: 50px;
  height: 50px;
  color: white;
  background-color: transparent;
  border: none;
  z-index: 999;
}

.section-close-button.right {
  top: 50%;
  left: -50px;
  transform: translateY(-50%);
}

.section-close-button.left {
  top: 50%;
  right: -50px;
  transform: translateY(-50%);
}

.section-close-button.top {
  bottom: -50px;
  left: 50%;
  transform: translateX(-50%);
}

.section-close-button.bottom {
  top: -50px;
  left: 50%;
  transform: translateX(-50%);
}

.section-close-button.is-mobile {
  display: none;
}
</style>
